module.exports = __webpack_public_path__ + "img/health15_7-9-2021.539fdd4a.jpg";